import { decamelizeKeys } from 'humps';
import { CHECKR_BFF_API_BASE } from 'constants';
import { request } from './helper';

/*
 * Action Types
 */

export const ACCEPT_TOS_SUCCESS = 'ACCEPT_TOS_SUCCESS';
export const acceptTosAction = () => ({ type: ACCEPT_TOS_SUCCESS });

/*
 * Actions
 */

export const acceptTos = values => dispatch => {
  const options = {
    method: 'POST',
    body: JSON.stringify(decamelizeKeys(values)),
  };

  return request(
    `${CHECKR_BFF_API_BASE}/applicants/${values.applicantId}/terms_of_service`,
    options,
  ).then(() => {
    dispatch(acceptTosAction());
  });
};
